import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import DateInput from "components/Input/DateInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import styled from "styled-components";
import { plan2dText } from "variables/MBM/geb";
import { plan2ddefaultviewData } from "variables/MBM/lists/geb";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postGEB2DPlan, putGEB2DPlan, getFiles } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import CustomSwitch from "components/Input/CustomSwitch.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;


function Plan2dDialog(props) {

  const { closeModal, refetch, setLoading, currentPlan, wpgroup, workspaceid } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);

  const { chartIdGroup } = advancedSearchContext;

  const [description, setDescription] = useState(currentPlan?.parameters.description || "");
  const [name, setName] = useState(currentPlan?.parameters.name || "");
  // const [category, setCategory] = useState(currentPlan?.parameters.category || "");
  const [image, setImage] = useState(currentPlan?.parameters.image || "");
  const [isdefault, setIsdefault] = useState(currentPlan?.parameters.isdefault || "");

  const [defaultview, setDefaultview] = useState(currentPlan?.parameters.defaultview || "none");
  const [displayiot, setDisplayiot] = useState((currentPlan && currentPlan.parameters && "displayiot" in currentPlan.parameters)? currentPlan.parameters.displayiot : true);
  const [displayeq, setDisplayeq] = useState((currentPlan && currentPlan.parameters && "displayeq" in currentPlan.parameters)? currentPlan.parameters.displayeq : true);
  const [displaydata, setDisplaydata] = useState((currentPlan && currentPlan.parameters && "displaydata" in currentPlan.parameters)? currentPlan.parameters.displaydata : true);

  const [gedList, setGedList] = useState([]);

  const [groups, setGroups] = useState(currentPlan?.groupid ? "" + currentPlan.groupid : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const classes = useStyles();

  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  // const handleCategoryChange = (event) => { setCategory(event.target.value); };
  const handleImageChange = (newValue) => { setImage(newValue); };
  const handleIsdefaultChange = (event) => { setIsdefault(!isdefault); };

  const handleDefaultviewChange = (event) => { setDefaultview(event.target.value); };
  const handleDisplayiotChange = (event) => { setDisplayiot(!displayiot); };
  const handleDisplayeqChange = (event) => { setDisplayeq(!displayeq); };
  const handleDisplaydataChange = (event) => { setDisplaydata(!displaydata); };

  console.log(displayiot,displayeq,displaydata);

  const selectedGed = () => {
    let selected;
    if (image) {
      selected = image;
    }
    return selected;
  };

  const handleSubmit = (event) => {
    if (currentPlan)
      updatePlan(event);
    else
      createPlan(event);
  };

  useEffect(() => {
    if (!name || !groups || !image || groups === '0')
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  useEffect(() => {
    let gedlisttmp = [];
    axios
      .get(
        getFiles(wpgroup, "png"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.data?.status && res.data.status === 'ok')
          gedlisttmp = gedlisttmp.concat(res.data.collection);
        console.log(gedlisttmp);
        axios
          .get(
            getFiles(wpgroup, "jpg"),
            {
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((res) => {
            if (res.data?.status && res.data.status === 'ok')
              gedlisttmp = gedlisttmp.concat(res.data.collection);
            console.log(gedlisttmp);
            setGedList(gedlisttmp);
          });
      })
  }, []);

  const createPlan = async (event) => {
    let newplan = {
      parameters: {
        name,
        description,
        image,
        isdefault,
        defaultview,
        displayiot,
        displayeq,
        displaydata
        // category
      }
    }
    axios
      .post(
        postGEB2DPlan(groups, workspaceid),
        newplan
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Plan créé");
          refetch(res.data.id);
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };

  const updatePlan = async (event) => {
    let newplanparameters = {
      ...currentPlan.parameters,
      description,
      name,
      image,
      isdefault,
      defaultview,
      displayiot,
      displayeq,
      displaydata
      // category
    }
    axios
      .put(
        putGEB2DPlan(currentPlan.id, groups),
        newplanparameters
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Plan modifié");
          refetch(currentPlan.id);
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                inputTitle={plan2dText.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                required
              />
            </div>
            {/* <div>
              <TextInput
                inputTitle={plan2dText.category}
                textInput={category}
                handleTextInputChange={handleCategoryChange}
                required
              />
            </div> */}
            <div>
              <AutocompleteInput
                isMultiple={false}
                specialWidth={"97%"}
                inputTitle={plan2dText.image}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleImageChange(newValue)
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={plan2dText.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={plan2dText.isdefault}
                checkedState={isdefault}
                handleSwitchChange={handleIsdefaultChange}
              />
            </div>
            <div>
              <CustomSelect
                marginTop={5}
                width={200}
                inputTitle={plan2dText.defaultview}
                selectValue={defaultview}
                handleSelectValueChange={handleDefaultviewChange}
                data={plan2ddefaultviewData}
                small
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={plan2dText.displayiot}
                checkedState={displayiot}
                handleSwitchChange={handleDisplayiotChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={plan2dText.displayeq}
                checkedState={displayeq}
                handleSwitchChange={handleDisplayeqChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={plan2dText.displaydata}
                checkedState={displaydata}
                handleSwitchChange={handleDisplaydataChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>{plan2dText.group}</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={"" + wpgroup}
                  cantSelectZero={true}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default Plan2dDialog;
